import { QueryKey, useQuery, UseQueryOptions } from "react-query";
import { useCurrentTrip } from "@/hooks";
import { TASK_ENDPOINT } from "./constants";
import useFetchWithAuth from "../fetchWithAuth";

type Task = Partial<{
  id: number;
  tid: number;
  task_id: number;
  complete: number;
  status: string;
  _ca: number;
  _cb: number;
  _lma: null;
  _lmb: null;
}>;

type TaskResult = {
  success: boolean;
  result: Array<Task>;
};

type QueryError = {};

const useTripTasksQuery = (
  options?: UseQueryOptions<TaskResult, QueryError, TaskResult, QueryKey>
) => {
  const { currentTrip } = useCurrentTrip();
  const tid = currentTrip?.id;
  const url = `${TASK_ENDPOINT}/trip-task/trip/${tid}`;
  const cacheKey = [url];
  const { fetchWithAuth } = useFetchWithAuth();

  return useQuery<TaskResult, QueryError>(
    cacheKey,
    async () => {
      if (!tid) throw new Error();
      return fetchWithAuth<TaskResult>(url);
    },
    {
      ...options,
    }
  );
};
export default useTripTasksQuery;
